export default "__VITE_ASSET__DojOey3n__"